import { useEditorEventCallback } from "@handlewithcare/react-prosemirror";

import { usePageFromCurrentRoute } from "@moment/state";
import { makeToast } from "@moment/ui";

import { useDeleteConfirmModal } from "~/components/common/useDeleteConfirmModal";
import { useSendToCodeEditorStore } from "~/state/machines/code-editor";

import { findDescendants } from "../easel/prosemirror/helpers/findDescendants";

export function useEaselDeleteComputeCell() {
	const { deleteConfirmation } = useDeleteConfirmModal();
	const send = useSendToCodeEditorStore();
	const { pageMetadata } = usePageFromCurrentRoute();

	return useEditorEventCallback(async (view, cellID: string) => {
		const [cell] = findDescendants(view.state.doc, (node) => node.attrs["id"] === cellID);
		const cellName = cell?.node.attrs["cellName"];

		const confirmStatus = await deleteConfirmation({
			headingTitle: "Delete cell",
			name: cellName || "this cell",
		});
		if (!confirmStatus) {
			return;
		}

		if (!cell) {
			makeToast({
				message: `Unable to delete cell with id ${cellID}`,
				variant: "error",
				timer: "timed-dismissible",
			});

			return;
		}

		send({ type: "closeTab", cellID, activePageID: pageMetadata?.id });

		let tr = view.state.tr;
		tr = tr.delete(cell.pos, cell.pos + cell.node.nodeSize);

		view.dispatch(tr.scrollIntoView());
		view.focus();

		makeToast({
			message: `Deleted cell`,
			variant: "success",
			timer: "timed-dismissible",
		});
	});
}
